import {Component}                    from 'react'
import IMAGE_QR_code_0                from '../../assets/images/qr_code_0.png';
import IMAGE_QR_code_1                from '../../assets/images/qr_code_1.jpg';
import IMAGE_QR_code_2                from '../../assets/images/qr_code_2.jpg';
import IMAGE_QR_code_3                from '../../assets/images/qr_code_3.png';
import WX_Image                       from '../../assets/images/wx.png';
import './index.css';
import PurchaseModal                  from './PurchaseModal'

const channelList = new Map([
    ["淘宝", {key:"taobao", userType: 'TB',  href:"https://oauth.taobao.com/authorize?response_type=code&client_id=21611901&redirect_uri=https://lt.800best.com/login/taobao"}],
    ["拼多多", {key:"pdd",userType: 'PDD', href:"https://fuwu.pinduoduo.com/service-market/auth?response_type=code&client_id=79c42ae725e746ba86cbf36d2d846fd2&redirect_uri=http://ltpdd.800best.com/login/pdd&tdsourcetag=s_pctim_aiomsg"}],
    ["1688", {key:"1688",userType: '1688', href:"https://gw.open.1688.com/auth/authorize.htm?site=china&_aop_signature=E145E23150D531E7EBB030CB3934582D30E48572&response_type=code&client_id=1023657&redirect_uri=https://lt.800best.com/login/Ali"}],
    ["京东", {key:"jd",userType: 'JD', href:"https://oauth.jd.com/oauth/authorize?response_type=code&client_id=561AC1A8676CFCB0CC61B041AE42ABB8&redirect_uri=http://116.196.91.252/login/JD"}],
    ["抖音小店", {key:"dy",userType: 'DY', href:"https://fuwu.jinritemai.com/authorize?from=yinliu&service_id=21432"}],
    ["快手小店", {key:"ks",userType: 'KSXD', href:"https://open.kwaixiaodian.com/oauth/authorize?app_id=ks649362771974749528&response_type=code&scope=merchant_refund,user_info,merchant_item,merchant_order,merchant_user,merchant_servicemarket&redirect_uri=https://lt.800best.com/login/ksxd"}],
    ["小红书", {key:"xhs",userType: 'XHS', href:"https://ark.xiaohongshu.com/ark/authorization?appId=a6fc7bf7b2544c9da26c&redirectUri=http://lt.800best.com/lg/xhs"}],
    ["视频号", {key:"sph",userType: 'SPH', href:"https://channels.weixin.qq.com/shop"}]
]);

class ChannelPurchase extends Component{
  constructor (props) {
    super()
    this.state = {
      showModal: false,
      modalData: {}
    }
  }

  handlePurchase = (item) =>{
    const {sign, inviteCode} = this.props
    if(!inviteCode){
      window.open(item.href)
    }else {
      this.setState({
          showModal: true,
          modalData: {
            ...item,
            sign,
            inviteCode
          }
        }
      )
    }

  }

  render() {
    return (
      <>
        <div className="purchase__header">
          <header>
            <a href="/channelPurchase" className="purchase__logo" alt="灵通打单">灵通打单</a>
            <span className="purchase__nav--link">
              <a href="http://q.url.cn/cdHPiP?_type=wpa&qidian=true" className="nav--link purchase__support"
                 alt="客服咨询">客服咨询&gt;&gt;</a>
              <a href="http://lt.800best.com" className="nav--link purchase__goto" alt="灵通打单官网">登录灵通打单&gt;&gt;</a>
            </span>
          </header>
        </div>
        <div className="content">
          <section className="purchase__banner"></section>
          <section className="purchase__link">
            <header>现在订购</header>
            <div className="purchase__qrcore--desc">对接各大电商平台，批量打印发货</div>
            <div className="purchase__link--content">
              {
                [...channelList].map(([name, item]) =>
                  <div key={name} className="purchase__link--item">
                    <span className="purchase__label">{name}</span>
                    <div className={`purchase__icon purchase__icon--${item.key}`}></div>
                    <a rel="noreferrer"
                       onClick={this.handlePurchase.bind(this, item)}>前往订购&gt;</a>
                  </div>)
              }

              {
                // append more empty items to make the layout looks better
                [...Array(12 - channelList.size).keys()].map((i) =>
                  <div key={i} className="purchase__link--item placeHolder"></div>)
              }
            </div>
          </section>
          <section className="purchase__qrcore">
            <header>30W+电商人都在使用</header>
            <div className="purchase__qrcore--desc">开店必备，高效打印发货神器</div>
            <div className="purchase__qrcore--list">
              <div className="purchase__qrcore--item">
                <img alt="" src={IMAGE_QR_code_0}/>
                <div>新手使用教程</div>
              </div>
              <div className="purchase__qrcore--item">
                <img alt="" src={IMAGE_QR_code_1}/>
                <div>了解重要公告</div>
              </div>
              <div className="purchase__qrcore--item">
                <img alt="" src={IMAGE_QR_code_2}/>
                <div>手机打印发货</div>
              </div>
              <div className="purchase__qrcore--item">
                <img alt="" src={IMAGE_QR_code_3}/>
                <div>手机视频教程</div>
              </div>
            </div>
          </section>
        </div>
        <div className="purchase__footer">
          <footer>
            <img src={WX_Image} alt=""/>联系微信：lingtongdadan
          </footer>
        </div>
        <PurchaseModal
          visible={this.state.showModal}
          data={this.state.modalData}
          onClose={()=> this.setState({showModal: false})}
        />
      </>
    );
  }
}

export default ChannelPurchase;
